import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PlaneacionService } from 'src/app/services/planeacion.service';
import { Revisiones } from 'src/app/types/type';
declare var $: any;

@Component({
  selector: 'app-form-edit-revision',
  templateUrl: './form-edit-revision.component.html',
  styleUrls: ['./form-edit-revision.component.css']
})
export class FormEditRevisionComponent {
  @Input() objetivo: string;
  @Input() alcance: string;
  @Input() idRevision: number;
  @Output() revisionUpdate = new EventEmitter()
  form: FormGroup;
  btnDisabled = false;

  constructor(private formBuilder: FormBuilder, private revisionServicio: PlaneacionService) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      objetivo: ['', [Validators.required]],
      alcance: ['', [Validators.required]],
    })
  }

  ngOnChanges(changes: SimpleChanges) {    
    if (!changes['objetivo'].firstChange && !changes['alcance'].firstChange) {
      this.form.setValue({
        objetivo: this.objetivo,
        alcance: this.alcance
      })
    }
  }
  
  editarRevision() {
    this.btnDisabled = true;
    const {
      objetivo,
      alcance
    } = this.form.value;

    const revision = {
      id: this.idRevision,
      objetivo,
      alcance
    }

    this.revisionServicio.actualizarRevision(revision)
      .subscribe(response => {
        if (response.Result.Exito) {
          const revision = response.Result.Data as Revisiones
          this.revisionUpdate.emit({
            idRevision: revision.IdRevision,
            objetivo: revision.objetivo,
            alcance: revision.alcance
          })
          this.form.reset();
          $('#modalEditObjetivo').modal('hide');
          this.btnDisabled = false;
        }
      })
  }
}
